import { wxshare } from '@/assets/js/api'
import wx from 'weixin-js-sdk'
/**
 * 禁止微信分享
 */

function onBridgeReady () {
  // CRM渠道不能分享
  wx.hideOptionMenu()
}

export function isShare () {
  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}
isShare()
